import CookieHelper from './CookieHelper'

class HubSpotFormHandler {
    formElementSelector = '.js-hubspot-form__form'
    formContentCollectionSelector = '.js-hubspot-form__content'
    successElementSelector = '.js-hubspot-form__success'
    leadWallWrapperSelector = '.js-hubspot-lead-wall'

    constructor(formWrapperElement, group) {
        this.formWrapperElement = formWrapperElement
        this.leadWallWrapper = formWrapperElement.closest(this.leadWallWrapperSelector)
        this.formContentCollection = formWrapperElement.closest(this.formContentCollectionSelector)
        this.group = group
        this.submitButton = null
        this.recognizer = HubSpotFormRecognizer.getInstance()

        if (this.hasSubmission()) {
            // hide form
            this.formContentCollection.hidden = true
            // show success content
            this.leadWallWrapper.querySelector(this.successElementSelector).hidden = false
        } else {
            // this uses the hubspot event "onFormReady" so be sure our event listener is set before event is fired
            this.addSubmitButtonRecognizerEvent()
            // If the HubSpot script is not yet loaded
            if (typeof hbspt === 'undefined') {
                // Wait until the script from hubspot is fully loaded, then initialize the form
                document.querySelector('#hubspot-form-script').addEventListener('load', () => {
                    this.initializeForm()
                })
            } else {
                this.initializeForm()
            }

            // show form
            this.formContentCollection.hidden = false
            // hide success content
            this.leadWallWrapper.querySelector(this.successElementSelector).hidden = true
        }
    }

    /**
     * Initializes the current form and adds Event listeners for form subscription
     */
    initializeForm() {
        this.formWrapperElement.dispatchEvent(new Event('startHsFormInitialization'))
        this.addSubmissionEvent()
    }

    /**
     * used to add an event on submit button and wait for hubspot form creation event if necessary
     */
    addSubmitButtonRecognizerEvent() {
        // try to get submit button
        this.submitButton = this.formWrapperElement.querySelector('input[type="submit"]')
        if (!this.submitButton) {
            // wait until hubspot form is created
            window.addEventListener('message', (event) => {
                if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                    this.submitButton = this.formWrapperElement.querySelector('input[type="submit"]')
                    if (this.submitButton) {
                        // submit button is present so add action on click
                        this.addSubmitButtonClickAction()
                    }
                }
            })
        } else {
            // submit button is present so add action on click
            this.addSubmitButtonClickAction()
        }
    }

    /**
     * used to identify the correct form after submitted form
     */
    addSubmitButtonClickAction() {
        this.submitButton.addEventListener('click', (event) => {
            this.recognizer.addCurrentGroup(this.group)
        })
    }

    /**
     * Adds Events listeners for form subscription, based on Hubspot API Events
     */
    addSubmissionEvent() {
        /**
         * See https://legacydocs.hubspot.com/global-form-events for all API events
         *
         * Called after the form has been submitted and submission has been persisted
         *
         * {
         *         type: 'hsFormCallback',
         *         eventName: 'onFormSubmitted',
         *         id: 'Id of form submitted',
         *         data: {}
         *  }
         */
        window.addEventListener('message', (event) => {
            // is submitted and is hsFormCallback
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                // and its the current transmitted form
                // if is splitted because hubspot fires to much message events and we want to avoid error "Maximum call stack size exceeded" for the Recognizer
                if (this.recognizer.currentGroup === this.group) {
                    if (this.group.includes('hubSpotForm__leadWall')) {
                        this.saveSubmission()
                    }

                    // hide form
                    this.formContentCollection.hidden = true
                    // show success content
                    this.leadWallWrapper.querySelector(this.successElementSelector).hidden = false
                }
            }
        })
    }

    saveSubmission() {
        CookieHelper.setCookie(this.group, 'submission', 30)
    }

    hasSubmission() {
        return CookieHelper.isCookieSet(this.group)
    }
}

class HubSpotFormRecognizer {
    static getInstance() {
        if (!HubSpotFormRecognizer.instance) {
            Object.defineProperty(HubSpotFormRecognizer, 'instance', {
                value: new HubSpotFormRecognizer(),
                writable: true,
                enumerable: true,
                configurable: false,
            })
        }
        return HubSpotFormRecognizer.instance
    }

    currentGroupName

    constructor() {}

    addCurrentGroup(groupName) {
        this.currentGroupName = groupName
    }

    get currentGroup() {
        return this.currentGroupName
    }
}

export default function initializeHubSpotFormHandlers() {
    // When wrapped in the Cookie Consent Content NodeType the Forms have to be initialized asynchronously
    document.addEventListener('beforeHubSpotFormCreate', () => {
        initializeHubSpotFormHandlers()
    })

    let formsToHandle = document.querySelectorAll('.js-hubspot-form')

    formsToHandle.forEach((formWrapperElement) => {
        // Prevent multiple initializations of one form
        if (formWrapperElement.classList.contains('initialized')) {
            return
        }

        formWrapperElement.classList.add('initialized')

        let groupName = formWrapperElement.dataset.group

        if (
            (groupName.includes('hubSpotForm__leadWall') || groupName.includes('hubSpotForm__newsletter')) &&
            !document.body.classList.contains('neos-backend')
        ) {
            new HubSpotFormHandler(formWrapperElement, groupName)
        } else {
            // If the HubSpot script is not yet loaded
            if (typeof hbspt === 'undefined') {
                // Wait until the script from hubspot is fully loaded, then initialize the form
                document.querySelector('#hubspot-form-script').addEventListener('load', () => {
                    formWrapperElement.dispatchEvent(new Event('startHsFormInitialization'))
                })
            } else {
                formWrapperElement.dispatchEvent(new Event('startHsFormInitialization'))
            }
        }
    })
}
